if (typeof CartBuildBoxRemoveButton === 'undefined') {
	class CartBuildBoxRemoveButton extends HTMLElement {
		connectedCallback() {
			if (this.dataset.bound === 'true') return;
			this.dataset.bound = 'true';

			const control = this.querySelector('button, a');
			if (!control) return;

			control.addEventListener(
				'click',
				(e) => {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();

					const groupRow = this.closest('.cart-item--build-box-group, .cart-item--design-box-group');
					const keysString =
						this.dataset.buildBoxKeys || groupRow?.dataset.buildBoxKeys || '';
					const cartForm =
						this.closest('cart-form') || document.getElementById('AjaxCartForm');

					if (keysString && typeof cartForm?.removeBuildBoxGroup === 'function') {
						cartForm.removeBuildBoxGroup(keysString);
					}
				},
				true
			);
		}
	}

	if (typeof customElements.get('cart-build-box-remove-button') === 'undefined') {
		customElements.define('cart-build-box-remove-button', CartBuildBoxRemoveButton);
	}
}
